import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { Menu, X, Home, LogIn, UserPlus, LayoutDashboard, TrendingUp, ArrowDownToLine, LifeBuoy, UserCircle, KeyRound } from "lucide-react";
import { Logo } from "@/components/AppLayout";
import { ThemeToggle } from "@/components/ThemeToggle";

const LINKS = [
  { to: "/", label: "Home", Icon: Home },
  { to: "/login", label: "Login", Icon: LogIn },
  { to: "/register", label: "Create Account", Icon: UserPlus },
  { to: "/forgot-password", label: "Reset Password", Icon: KeyRound },
  { to: "/dashboard", label: "Dashboard", Icon: LayoutDashboard },
  { to: "/profile", label: "Profile", Icon: UserCircle },
  { to: "/funding", label: "Contribution", Icon: TrendingUp },
  { to: "/withdrawals", label: "Withdrawals", Icon: ArrowDownToLine },
  { to: "/support", label: "Support", Icon: LifeBuoy },
];

export function PublicMobileNav() {
  const [open, setOpen] = useState(false);
  return (
    <div className="md:hidden">
      <button
        onClick={() => setOpen(true)}
        data-testid="public-menu-toggle"
        aria-label="Open menu"
        aria-expanded={open}
        className="p-2 rounded-lg border border-white/10 bg-[#0A132A] text-white hover:border-[#00F0FF]/40 transition-all"
      >
        <Menu size={20} />
      </button>

      {createPortal(
        <>
          {open && (
            <div className="md:hidden fixed inset-0 z-[80] bg-black/60 backdrop-blur-sm" onClick={() => setOpen(false)} data-testid="public-nav-backdrop" />
          )}
          <aside
            className={`md:hidden fixed top-0 left-0 z-[90] h-screen w-72 max-w-[82vw] glass-strong border-r border-white/10 p-5 transform transition-transform duration-300 ease-out ${open ? "translate-x-0" : "-translate-x-full"}`}
            data-testid="public-nav-drawer"
            aria-hidden={!open}
          >
            <div className="flex items-center justify-between mb-8">
              <Logo />
              <button onClick={() => setOpen(false)} data-testid="public-menu-close" className="p-2 rounded-lg hover:bg-white/5">
                <X size={20} />
              </button>
            </div>
            <nav className="flex flex-col gap-1.5">
              {LINKS.map(({ to, label, Icon }) => (
                <Link key={to} to={to} onClick={() => setOpen(false)} className="side-link" data-testid={`public-nav-${label.toLowerCase().replace(/\s+/g, "-")}`}>
                  <Icon size={18} strokeWidth={1.6} />
                  <span className="text-sm">{label}</span>
                </Link>
              ))}
            </nav>
            <div className="mt-8 pt-5 border-t border-white/10 flex items-center justify-between">
              <span className="text-xs uppercase tracking-[0.2em] text-[#475569] font-bold">Theme</span>
              <ThemeToggle />
            </div>
          </aside>
        </>,
        document.body
      )}
    </div>
  );
}
